const constants = {
    URLS: {
        MAX_LENGTH: 100
    },
    URL_FORMATS: {
        SLASH: 'slash',
        HASH_BANG: 'hashBang'
    },
    DEVICES: ['desktop', 'mobile'],
    MASTER_PAGE_ID: 'masterPage',
    COMP_IDS: {
        PAGE_GROUP: 'SITE_PAGES',
        PAGES_CONTAINER: 'PAGES_CONTAINER',
        HEADER: 'SITE_HEADER',
        FOOTER: 'SITE_FOOTER',
        BACKGROUND: 'SITE_BACKGROUND',
        QUICK_ACTION_BAR: 'QUICK_ACTION_BAR',
        WIX_ADS: 'WIX_ADS',
        WINDOW: 'WINDOW'
    },
    SAFE_PADDING_FOR_URI_LENGTH: 5,
    CUSTOM_MAIN_MENU: 'CUSTOM_MAIN_MENU',
    HINTS_PROPERTIES: {
        GENERAL_HINTS_PROPERTIES: ['id', 'metaData', 'type'],
        GENERAL_PRESET_DATA: ['author'],
        SIZE_DATA: ['recommendedHeight', 'recommendedWidth', 'recommendedScale', 'originalCompId'],
        OFFSET_DATA: ['offsetX', 'offsetY', 'offsetOrigin', 'orderIndex']
    }
}

export {constants}
